import React from 'react'
import Manager from '../../public/components/Manager'
import PersonInfoDiv from './PersonInfoDiv'
Ext.require('Ext.Toast')

const config = ({ roles }) => {
	return {
		buttons: [
		],
		columns: [
			{ _text: '姓名', field: 'ActualName', search: true, minWidth: 150/* , tools: tipTools */ },
			{ _text: '工号', field: 'PersonNo', search: true, minWidth: 150 },
			{ _text: '职务', field: 'PersonDuty', search: true, minWidth: 150 },
			{ _text: '所在部门', field: 'Dep.DepName', search: true, minWidth: 150, flex: 1, renderer: v => v ? v.split('/')[v.split('/').length - 1] : '' },
			{ _text: '手机号码', field: 'PersonMobile', search: true, minWidth: 150 },
			{ _text: '邮箱', field: 'PersonEmail', search: true, minWidth: 200, flex: 1, },
			{ _text: '座机', field: 'PersonOfficeTel', minWidth: 50, search: true, renderer: v => v ? v.split('-')[v.split('-').length - 1] : '' },
		],
	}
}
export default props => <Manager {...props} config={config} />